<!-- <mat-sidenav-container fullscreen>

  <mat-sidenav #start (click)="start.close()">
    <mat-nav-list> -->

      <!-- <a mat-list-item routerLink="/">
        <mat-icon>library_books</mat-icon>
        <span>Courses</span>
      </a> -->

      <!-- <a mat-list-item routerLink="/">
        <mat-icon>person_add</mat-icon>
        <span>Students</span>
      </a> -->

      <!-- <a mat-list-item routerLink="/students">
        <mat-icon>person_add</mat-icon>
        <span>Students</span>
      </a> -->

      <!-- <a mat-list-item routerLink="/create-user">
        <mat-icon>add_circle_outline</mat-icon>
        <span>Create user</span>
      </a>

      <a mat-list-item routerLink="about">
        <mat-icon>question_answer</mat-icon>
        <span>About</span>
      </a>
      <a mat-list-item routerLink="login">
        <mat-icon>person_add</mat-icon>
        <span>Register</span>
      </a>

      <a mat-list-item routerLink="login">
        <mat-icon>account_circle</mat-icon>
        <span>Login</span>
      </a>

      <a mat-list-item>
        <mat-icon>exit_to_app</mat-icon>
        <span>Logout</span>
      </a> -->

    <!-- </mat-nav-list>

  </mat-sidenav> -->

  <!-- <mat-toolbar color="primary">

    <div class="toolbar-tools">

      <button mat-icon-button (click)="start.open('mouse')">
        <mat-icon>menu</mat-icon>
      </button>

      <div class="filler"></div>

      <ng-container>

        <img class="user-avatar">

      </ng-container>

    </div>


  </mat-toolbar> -->

  <!-- <router-outlet></router-outlet>

</mat-sidenav-container> -->

<!-- <app-dashboard></app-dashboard> -->

<login *ngIf="!(authenticationService.userData | async)"></login>

<div class="main-wrapper" *ngIf="authenticationService && authenticationService.userData | async">
  <div class="header">
     <div class="header-left">
        <a href="index.html" class="logo">
        <img src="assets/img/44.png" alt="Logo">
        </a>
        <a href="index.html" class="logo logo-small">
        <img src="assets/img/pen-64.png" alt="Logo" width="30" height="30">
        </a> 
     </div>
     <a href="javascript:void(0);" id="toggle_btn">
     <i class="fas fa-align-left"></i>
     </a>
     <div class="top-nav-search">
        <form>
           <input type="text" class="form-control" placeholder="Search here">
           <button class="btn" type="submit"><i class="fas fa-search"></i></button>
        </form>
     </div>
     <a class="mobile_btn" id="mobile_btn">
     <i class="fas fa-bars"></i>
     </a>
     <ul class="nav user-menu">
        <li class="nav-item dropdown noti-dropdown">
           <a href="#" class="dropdown-toggle nav-link" data-toggle="dropdown">
           <i class="far fa-bell"></i> <span class="badge badge-pill">3</span>
           </a>
           <div class="dropdown-menu notifications">
              <div class="topnav-dropdown-header">
                 <span class="notification-title">Notifications</span>
                 <a href="javascript:void(0)" class="clear-noti"> Clear All </a>
              </div>
              <div class="noti-content">
                 <ul class="notification-list">
                    <li class="notification-message">
                       <a href="#">
                          <div class="media">
                             <span class="avatar avatar-sm">
                             <img class="avatar-img rounded-circle" alt="User Image" src="assets/img/profiles/avatar-02.jpg">
                             </span>
                             <div class="media-body">
                                <p class="noti-details"><span class="noti-title">Carlson Tech</span> has approved <span class="noti-title">your estimate</span></p>
                                <p class="noti-time"><span class="notification-time">4 mins ago</span></p>
                             </div>
                          </div>
                       </a>
                    </li>
                    <li class="notification-message">
                       <a href="#">
                          <div class="media">
                             <span class="avatar avatar-sm">
                             <img class="avatar-img rounded-circle" alt="User Image" src="assets/img/profiles/avatar-11.jpg">
                             </span>
                             <div class="media-body">
                                <p class="noti-details"><span class="noti-title">International Software Inc</span> has sent you a invoice in the amount of <span class="noti-title">$218</span></p>
                                <p class="noti-time"><span class="notification-time">6 mins ago</span></p>
                             </div>
                          </div>
                       </a>
                    </li>
                    <li class="notification-message">
                       <a href="#">
                          <div class="media">
                             <span class="avatar avatar-sm">
                             <img class="avatar-img rounded-circle" alt="User Image" src="assets/img/profiles/avatar-17.jpg">
                             </span>
                             <div class="media-body">
                                <p class="noti-details"><span class="noti-title">John Hendry</span> sent a cancellation request <span class="noti-title">Apple iPhone XR</span></p>
                                <p class="noti-time"><span class="notification-time">8 mins ago</span></p>
                             </div>
                          </div>
                       </a>
                    </li>
                    <li class="notification-message">
                       <a href="#">
                          <div class="media">
                             <span class="avatar avatar-sm">
                             <img class="avatar-img rounded-circle" alt="User Image" src="assets/img/profiles/avatar-13.jpg">
                             </span>
                             <div class="media-body">
                                <p class="noti-details"><span class="noti-title">Mercury Software Inc</span> added a new product <span class="noti-title">Apple MacBook Pro</span></p>
                                <p class="noti-time"><span class="notification-time">12 mins ago</span></p>
                             </div>
                          </div>
                       </a>
                    </li>
                 </ul>
              </div>
              <div class="topnav-dropdown-footer">
                 <a href="#">View all Notifications</a>
              </div>
           </div>
        </li>
        <li class="nav-item dropdown has-arrow">
           <a href="#" class="dropdown-toggle nav-link" data-toggle="dropdown">
           <span class="user-img"><img class="rounded-circle" src="assets/img/profiles/avatar-01.jpg" width="31" alt="Ryan Taylor"></span>
           </a>
           <div class="dropdown-menu">
              <div class="user-header">
                 <div class="avatar avatar-sm">
                    <img src="assets/img/profiles/avatar-01.jpg" alt="User Image" class="avatar-img rounded-circle">
                 </div>
                 <div class="user-text">
                    <h6>Ryan Taylor</h6>
                    <p class="text-muted mb-0">Administrator</p>
                 </div>
              </div>
              <a class="dropdown-item" href="profile.html">My Profile</a>
              <a class="dropdown-item" href="inbox.html">Inbox</a>
              <a class="dropdown-item" href="login.html" (click)="signout()">Logout</a>
           </div>
        </li>
     </ul>
  </div>
  <div class="sidebar" id="sidebar">
     <div class="sidebar-inner slimscroll">
        <div id="sidebar-menu" class="sidebar-menu">
           <ul>
              <li class="menu-title">
                 <span>Main Menu</span>
              </li>
              <li class="submenu active">
                 <a href="#"><i class="fas fa-user-graduate"></i> <span> Dashboard</span> <span class="menu-arrow"></span></a>                
              </li>
              <li class="submenu">
                 <a  routerLink="/students"><i class="fas fa-user-graduate"></i> <span> Students</span> <span class="menu-arrow"></span></a>                
              </li>
              <li class="submenu">
                 <a routerLink="/teachers"><i class="fas fa-chalkboard-teacher"></i> <span> Teachers</span> <span class="menu-arrow"></span></a>                
              </li>             
             
           </ul>
        </div>
     </div>
  </div>
  <div class="page-wrapper">
     <div class="content container-fluid">
        <div class="page-header">
           <div class="row">
              <div class="col-sm-12">
                 <h3 class="page-title">Welcome Admin!</h3>
                 <ul class="breadcrumb">
                    <li class="breadcrumb-item active">Dashboard</li>
                 </ul>
              </div>
           </div>
        </div>
       
        <!-- <div class="row">
           <div class="col-md-12 col-lg-6">
              <div class="card card-chart">
                 <div class="card-header">
                    <div class="row align-items-center">
                       <div class="col-6">
                          <h5 class="card-title">Revenue</h5>
                       </div>
                       <div class="col-6">
                          <ul class="list-inline-group text-right mb-0 pl-0">
                             <li class="list-inline-item">
                                <div class="form-group mb-0 amount-spent-select">
                                   <select class="form-control form-control-sm">
                                      <option>Today</option>
                                      <option>Last Week</option>
                                      <option>Last Month</option>
                                   </select>
                                </div>
                             </li>
                          </ul>
                       </div>
                    </div>
                 </div>
                 <div class="card-body">
                    <div id="apexcharts-area"></div>
                 </div>
              </div>
           </div>
           <div class="col-md-12 col-lg-6">
              <div class="card card-chart">
                 <div class="card-header">
                    <div class="row align-items-center">
                       <div class="col-6">
                          <h5 class="card-title">Number of Students</h5>
                       </div>
                       <div class="col-6">
                          <ul class="list-inline-group text-right mb-0 pl-0">
                             <li class="list-inline-item">
                                <div class="form-group mb-0 amount-spent-select">
                                   <select class="form-control form-control-sm">
                                      <option>Today</option>
                                      <option>Last Week</option>
                                      <option>Last Month</option>
                                   </select>
                                </div>
                             </li>
                          </ul>
                       </div>
                    </div>
                 </div>
                 <div class="card-body">
                    <div id="bar"></div>
                 </div>
              </div>
           </div>
        </div> -->
        <!-- <div class="row">
           <div class="col-md-6 d-flex">
              <div class="card flex-fill">
                 <div class="card-header">
                    <h5 class="card-title">Star Students</h5>
                 </div>
                 <div class="card-body">
                    <div class="table-responsive">
                       <table class="table table-hover table-center">
                          <thead class="thead-light">
                             <tr>
                                <th>ID</th>
                                <th>Name</th>
                                <th class="text-center">Marks</th>
                                <th class="text-center">Percentage</th>
                                <th class="text-right">Year</th>
                             </tr>
                          </thead>
                          <tbody>
                             <tr>
                                <td class="text-nowrap">
                                   <div>PRE2209</div>
                                </td>
                                <td class="text-nowrap">John Smith</td>
                                <td class="text-center">1185</td>
                                <td class="text-center">98%</td>
                                <td class="text-right">
                                   <div>2019</div>
                                </td>
                             </tr>
                             <tr>
                                <td class="text-nowrap">
                                   <div>PRE1245</div>
                                </td>
                                <td class="text-nowrap">Jolie Hoskins</td>
                                <td class="text-center">1195</td>
                                <td class="text-center">99.5%</td>
                                <td class="text-right">
                                   <div>2018</div>
                                </td>
                             </tr>
                             <tr>
                                <td class="text-nowrap">
                                   <div>PRE1625</div>
                                </td>
                                <td class="text-nowrap">Pennington Joy</td>
                                <td class="text-center">1196</td>
                                <td class="text-center">99.6%</td>
                                <td class="text-right">
                                   <div>2017</div>
                                </td>
                             </tr>
                             <tr>
                                <td class="text-nowrap">
                                   <div>PRE2516</div>
                                </td>
                                <td class="text-nowrap">Millie Marsden</td>
                                <td class="text-center">1187</td>
                                <td class="text-center">98.2%</td>
                                <td class="text-right">
                                   <div>2016</div>
                                </td>
                             </tr>
                             <tr>
                                <td class="text-nowrap">
                                   <div>PRE2209</div>
                                </td>
                                <td class="text-nowrap">John Smith</td>
                                <td class="text-center">1185</td>
                                <td class="text-center">98%</td>
                                <td class="text-right">
                                   <div>2015</div>
                                </td>
                             </tr>
                          </tbody>
                       </table>
                    </div>
                 </div>
              </div>
           </div>
           <div class="col-md-6 d-flex">
              <div class="card flex-fill">
                 <div class="card-header">
                    <h5 class="card-title">Student Activity</h5>
                 </div>
                 <div class="card-body">
                    <ul class="activity-feed">
                       <li class="feed-item">
                          <div class="feed-date">Apr 13</div>
                          <span class="feed-text"><a>John Doe</a> won 1st place in <a>"Chess"</a></span>
                       </li>
                       <li class="feed-item">
                          <div class="feed-date">Mar 21</div>
                          <span class="feed-text"><a>Justin Lee</a> participated in <a href="invoice.html">"Carrom"</a></span>
                       </li>
                       <li class="feed-item">
                          <div class="feed-date">Feb 2</div>
                          <span class="feed-text"><a>Justin Lee</a>attended internation conference in <a href="profile.html">"St.John School"</a></span>
                       </li>
                       <li class="feed-item">
                          <div class="feed-date">Apr 13</div>
                          <span class="feed-text"><a>John Doe</a> won 1st place in <a>"Chess"</a></span>
                       </li>
                       <li class="feed-item">
                          <div class="feed-date">Mar 21</div>
                          <span class="feed-text"><a>Justin Lee</a> participated in <a href="invoice.html">"Carrom"</a></span>
                       </li>
                    </ul>
                 </div>
              </div>
           </div>
        </div> -->
        <!-- <div class="row">
           <div class="col-xl-3 col-sm-6 col-12">
              <div class="card flex-fill fb sm-box">
                 <i class="fab fa-facebook"></i>
                 <h6>50,095</h6>
                 <p>Likes</p>
              </div>
           </div>
           <div class="col-xl-3 col-sm-6 col-12">
              <div class="card flex-fill twitter sm-box">
                 <i class="fab fa-twitter"></i>
                 <h6>48,596</h6>
                 <p>Follows</p>
              </div>
           </div>
           <div class="col-xl-3 col-sm-6 col-12">
              <div class="card flex-fill insta sm-box">
                 <i class="fab fa-instagram"></i>
                 <h6>52,085</h6>
                 <p>Follows</p>
              </div>
           </div>
           <div class="col-xl-3 col-sm-6 col-12">
              <div class="card flex-fill linkedin sm-box">
                 <i class="fab fa-linkedin-in"></i>
                 <h6>69,050</h6>
                 <p>Follows</p>
              </div>
           </div>
        </div> -->
     <router-outlet></router-outlet>
       </div>
     <footer>
        <p>Copyright © 2022 INSEVEN Technologies.</p>
     </footer>
  </div>
</div>


